import React from 'react';
import startcase from 'lodash.startcase';
import propDefs from '../proptypes';
import { setClassNames, getVehicleTypeLabel } from '../utils/utility';

import '../global-sass/main.scss';

export default class VehicleTitle extends React.Component {
	render() {
		if (
			Object.keys(this.props.vehicle).length === 0 &&
			this.props.vehicle.constructor === Object
		) {
			return null;
		}

		const {
			vehicle: {
				make,
				model,
				year,
				type,
				trim,
				bodyStyle,
				vin,
				stockNumber,
				customTitle,
				certified
			},
			deviceType,
			prefs: {
				usedVehicleTerm,
				titleDetailsSize,
				titleDetailsColor,
				titleHeading,
				titleHeadingColor,
				titleHeadingWeight,
				titleHeadingSize,
				titleHeadingTagLineWeight,
				titleHeadingTagLineSize
			},
			displayAttrsList,
			labels
		} = this.props;

		const displayCustomTitle = this.props.vehicle.customTitle.length;
		const customTitleLine = displayCustomTitle ? (
			<span
				className={setClassNames(
					'additional-details',
					'd-block',
					'mt-0',
					'mb-1',
					'font-weight-normal',
					titleDetailsSize,
					titleDetailsColor
				)}
			>
				{customTitle}
			</span>
		) : null;

		const displayAdditionalDetails =
			displayAttrsList.includes('vin') &&
			displayAttrsList.includes('stockNumber');
		const additionalDetails = displayAdditionalDetails ? (
			// ATTN: We need spaces between <li>'s
			// This fixes a strange double click selection issue in browsers
			<ul
				className={setClassNames(
					'additional-details',
					'list-inline',
					'my-0',
					'font-weight-normal',
					titleDetailsSize,
					titleDetailsColor
				)}
			>
				{vin && (
					<li>
						{`${labels.get('VIN')}: `}
						{vin}{' '}
					</li>
				)}
				{stockNumber && (
					<li>
						{` ${labels.get('STOCK')}: `}
						{stockNumber}{' '}
					</li>
				)}
				{/* This may be added back in at some point */}
				{/* {modelCode && <li> {labels.get('MODEL')}: {modelCode} </li>} */}
			</ul>
		) : null;

		const vehicleTypeLabel = getVehicleTypeLabel(
			labels,
			type.toUpperCase(), // Temp until VCDA data for type is fixed (capitalized)
			certified,
			usedVehicleTerm
		);

		let vehicleMarkup = (
			<h1>{startcase(labels.get('VEHICLE_UNAVAILABLE'))}</h1>
		);

		if (make && model && year) {
			vehicleMarkup = (
				<React.Fragment>
					<h1
						className={setClassNames(
							'vehicle-title',
							'm-0',
							'line-height-reset',
							deviceType !== 'DESKTOP' && 'h2'
						)}
					>
						<span
							className={setClassNames(
								'd-block',
								titleHeading,
								titleHeadingColor,
								titleHeadingWeight,
								titleHeadingSize
							)}
						>
							<span>{vehicleTypeLabel} </span>
							<span>{year} </span>
							<span>{make}</span>
						</span>
						<span
							className={setClassNames(
								titleHeadingTagLineWeight,
								titleHeadingTagLineSize
							)}
						>
							{model} {trim} {bodyStyle}
						</span>
						{customTitleLine}
					</h1>
					{additionalDetails}
				</React.Fragment>
			);
		}

		return vehicleMarkup;
	}
}

VehicleTitle.propTypes = {
	vehicle: propDefs.settings.vehicle,
	deviceType: propDefs.settings.deviceType.isRequired,
	prefs: propDefs.settings.prefs.isRequired,
	displayAttrsList: propDefs.settings.displayAttrsList,
	labels: propDefs.labels.isRequired
};

VehicleTitle.defaultProps = {
	vehicle: propDefs.defaults.vehicle,
	displayAttrsList: propDefs.defaults.displayAttrsList
};



// WEBPACK FOOTER //
// ./src/components/VehicleTitle.jsx